import { DS } from '../../design-system'
import { StyleSheet, Image, TouchableOpacity, View, Text } from 'react-native'
import { Palette } from '@ppwr/poker'
import InPersonImage from './assets/InPersonImage.png'
import VirtualEvent from './assets/VirtualEvent.png'
import Class from './assets/Class.png'
import NoneAbove from './assets/NoneAbove.png'
import Skeleton from 'react-native-reanimated-skeleton'
import { getDSColorWithOpacity } from '@/design-system/Palette'

export const Images = {
  InPersonImage,
  VirtualEvent,
  Class,
  NoneAbove
}

interface WhereAreYouChoiceProps {
  image: keyof typeof Images
  text: string
  onPress: () => void
}

export const WhereAreYouChoice = ({ image, text, onPress }: WhereAreYouChoiceProps) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <DS.Frame style={styles.textContainer}>
        <Image source={Images[image]} resizeMode={'contain'} style={styles.imageStyles} />
        <DS.Text variant="Heading 4/Medium">{text}</DS.Text>
      </DS.Frame>
      <DS.Icon name="Arrow---right" color="Global/Black" size={20} />
    </TouchableOpacity>
  )
}

export const WhereAreYouChoiceSkeleton = () => {
  return (
    <View style={styles.container}>
      <Skeleton
        containerStyle={{
          flex: 0,
          flexGrow: 1,
          minWidth: 300,
          width: '100%',
          flexDirection: 'row',
          alignItems: 'center'
        }}
        isLoading={true}
        highlightColor={getDSColorWithOpacity('Global/White', 0.5)}
        boneColor={DS.palette['Brand/Cream']}
        layout={[
          { key: 'image', width: 40, height: 40, borderRadius: 48 },
          { key: 'text', width: 200, height: 24, marginLeft: 12 }
        ]}
      />
    </View>
  )
}

export const styles = StyleSheet.create({
  container: {
    paddingLeft: 12,
    paddingRight: 24,
    paddingVertical: 12,
    borderRadius: 48,
    backgroundColor: Palette['Global/White'],
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12
  },
  imageStyles: {
    width: 40,
    height: 40
  }
})
